import { BadgeVariant } from 'uiComponents/badge'
import { LucideIconName } from 'utils/lucideIcon'
import { PricingPlanAction, PricingPlanStatus } from '../types'

interface PricingPlanStatusConfig {
    showDate: boolean
    showMemberCount: boolean
    badgeVariant?: BadgeVariant
    badgeLabel: string
    availableActions: PricingPlanAction[]
}

export const pricingPlanStatusConfig: Record<PricingPlanStatus, PricingPlanStatusConfig> = {
    draft: {
        showDate: false,
        showMemberCount: false,
        badgeVariant: 'info',
        badgeLabel: 'Draft',
        availableActions: ['activate', 'edit', 'remove'],
    },
    active: {
        showDate: true,
        showMemberCount: true,
        badgeVariant: 'success',
        badgeLabel: 'Active',
        availableActions: [],
    },
    open: {
        showDate: true,
        showMemberCount: true,
        badgeLabel: '',
        availableActions: ['migrate', 'discontinue', 'remove'],
    },
    migrating: {
        showDate: true,
        showMemberCount: true,
        badgeVariant: 'warning',
        badgeLabel: 'Migrating to active plan',
        availableActions: ['stop_migrating'],
    },
    discontinued: {
        showDate: true,
        showMemberCount: true,
        badgeVariant: 'neutral',
        badgeLabel: 'Discontinuing',
        availableActions: ['stop_discontinuing'],
    },
    closed: {
        showDate: true,
        showMemberCount: false,
        badgeVariant: 'neutral',
        badgeLabel: '',
        availableActions: [],
    },
    conditionally_migrating: {
        showDate: false,
        showMemberCount: true,
        badgeVariant: 'warning',
        badgeLabel: '',
        availableActions: [],
    },
}

export const kebabMenuLabels: Record<PricingPlanAction, { label: string; icon: LucideIconName }> = {
    activate: { label: 'Activate plan', icon: 'CircleCheck' },
    edit: { label: 'Edit plan', icon: 'Pencil' },
    remove: { label: 'Remove plan', icon: 'CircleX' },
    discontinue: { label: 'Discontinue plan', icon: 'CircleX' },
    migrate: { label: 'Migrate plan', icon: 'RefreshCcwDot' },
    stop_migrating: { label: 'Stop migration', icon: 'CircleX' },
    stop_discontinuing: { label: 'Stop discontinuing', icon: 'CircleX' },
}
